import { render, staticRenderFns } from "./ProjectManage.vue?vue&type=template&id=bf39007e&scoped=true&"
import script from "./ProjectManage.vue?vue&type=script&lang=js&"
export * from "./ProjectManage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManage.vue?vue&type=style&index=0&id=bf39007e&lang=scss&scoped=true&"
import style1 from "./ProjectManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf39007e",
  null
  
)

export default component.exports